import { defineMessages } from 'react-intl';

const messages = defineMessages({
  support_ticket: {
    id: 'gT4AkW',
    defaultMessage: 'Support Tickets',
  },
  administrative_cost: {
    id: 'lyHol5',
    defaultMessage: 'Administrative Costs',
  },
  percentage_fte_time_tooltip: {
    id: 'jwQIkA',
    defaultMessage:
      'This is the average percentage of time your storage FTEs spend on each storage activity.',
  },
  with_ibm: {
    id: 'I4oLT/',
    defaultMessage: 'With IBM',
  },
  see_your_results: {
    id: '5IrE0v',
    defaultMessage: 'Talk to an Expert',
  },
  average_time_to_close_ticket_tooltip: {
    id: 'hVGgUh',
    defaultMessage:
      'Enter the time it takes (minutes) to resolve/close these storage tickets.',
  },
  how_much_save: {
    id: '+28KD+',
    defaultMessage: 'See how much you could save with',
  },
  system_admin_salary_tooltip: {
    id: 'eVe7Jv',
    defaultMessage:
      'What is the average annual salary of an FTE currently managing your environment? The model is using a default of $120,000 plus a 36% burden rate which includes employee costs, benefits, etc.',
  },
  average_number_storage_tooltip: {
    id: '2G5lH/',
    defaultMessage:
      'Enter the average number of storage tickets received per month.',
  },
  reset_default: {
    id: 'Jmgbho',
    defaultMessage: 'Reset Defaults',
  },
  comparison: {
    id: 'P++Ru7',
    defaultMessage: 'Comparison',
  },
  esgibm_flashsystems: {
    id: '0k30mr',
    defaultMessage: 'ESG IBM Flashsystems',
  },
  ibm_flashsystem: {
    id: 'GDKVdQ',
    defaultMessage: 'IBM FlashSystem',
  },
  amount_of_storage: {
    id: 'uPZF8h',
    defaultMessage:
      'Enter that amount of storage space available on your storage system that can be effectively utilized for storing data. This capacity is the actual space that is accessible and available for storing files, documents, applications, or any other digital content after accounting for the space used by the system itself, formatting, overhead, redundancy, and other factors that might consume storage without being directly available for user data. ',
  },
  infrastructure_power: {
    id: 'dA+hnZ',
    defaultMessage: 'Infrastructure',
  },
  monitoring_environment: {
    id: '7V+6xX',
    defaultMessage: 'Montioring Environment',
  },
  aocost: {
    id: 'p4R26y',
    defaultMessage: 'A/0 cost',
  },
  storage_tco: {
    id: 'CIIHZ7',
    defaultMessage: 'Storage TCO',
  },
  planning_evaluations: {
    id: 'MUplTQ',
    defaultMessage: 'Planning / Evaluations',
  },
  administrator_operational_cost: {
    id: 'jnfQWT',
    defaultMessage: 'Administrative/Operational Cost',
  },
  system_admin_salary: {
    id: 'oT7djE',
    defaultMessage: 'System admin salary',
  },
  security_compliance: {
    id: 'd+AXjH',
    defaultMessage: 'Security / Compliance',
  },
  user_access: {
    id: 'a0UwG9',
    defaultMessage: 'User access',
  },
  number_of_admins: {
    id: 'ffdKLv',
    defaultMessage: 'Number of system admins',
  },
  accept_assumption: {
    id: 'dEPvQ5',
    defaultMessage: 'Accept Assumptions',
  },
  storage: {
    id: 'DUIDEq',
    defaultMessage: 'Storage',
  },
  administrator_operational_cost_ao: {
    id: 'sxh7Wn',
    defaultMessage: 'Administrative/Operational cost (A/O cost)',
  },
  percentage_fte_time: {
    id: 'j5ud52',
    defaultMessage:
      'Percentage of FTE time spent on storage-related activities (must sum to 100%)',
  },
  data_protection: {
    id: '47Sr2J',
    defaultMessage: 'Data protection',
  },
  total: {
    id: 'q4EmsW',
    defaultMessage: 'Total:',
  },
  how_modern_system: {
    id: 'MY2TWB',
    defaultMessage: 'How modern is your current system?',
  },
  annual_storage_savings: {
    id: '++bpFu',
    defaultMessage: '- Annual Storage Savings',
  },
  new_installs: {
    id: 'DLF99D',
    defaultMessage: 'New Installs',
  },
  currency: {
    id: '55hdQy',
    defaultMessage: 'Currency',
  },
  support_maintenance: {
    id: 'wgxFXH',
    defaultMessage: 'Support/Maintenance',
  },
  total_tooltip: {
    id: 'AkoRjq',
    defaultMessage:
      'Note: Since total effort must not exceed 100%, you must first reduce a slider before increasing another.',
  },
  annual_administrative_savings_benefits: {
    id: 'UwvNY4',
    defaultMessage: '- Annual Administrative Savings and Benefits',
  },
  average_time_to_close_ticket: {
    id: 'sonQlI',
    defaultMessage: 'Average time (minutes) to close tickets (before IBM)',
  },
  toggle_chart: {
    id: 'MeqXED',
    defaultMessage: 'Toggle Chart View',
  },
  percentage_of_fte: {
    id: 'xTgegq',
    defaultMessage: 'Percentage of FTE time spent managing storage',
  },
  monitoring_env: {
    id: 'n7e0ZO',
    defaultMessage: 'Monitoring the environment',
  },
  percentage_of_fte_toolip: {
    id: 'vO2oU5',
    defaultMessage:
      'What is the percentage of time is spent on managing storage.',
  },
  annual_cost_tco: {
    id: 'WHN2mW',
    defaultMessage: 'Annual Storage TCO',
  },
  how_modern_system_tooltip4: {
    id: 'Iw31TT',
    defaultMessage:
      'Fully Optimized = My organization uses Flash with management tools to optimize infrastructure',
  },
  average_number_storage: {
    id: '5DBeg3',
    defaultMessage: 'Average number of storage tickets per month',
  },
  application_opt: {
    id: 'DkW4hu',
    defaultMessage: 'Application optimization',
  },
  new_install_apps: {
    id: 'ewNVOu',
    defaultMessage: 'New installs / apps / scaling',
  },
  annual_administrative_savings: {
    id: 'Te3UfP',
    defaultMessage: 'Annual Administrative Savings',
  },
  number_of_people: {
    id: 'l9FJgI',
    defaultMessage: 'Enter the number of people who are managing your storage.',
  },
  lower_storage: {
    id: 'LuI9tQ',
    defaultMessage: 'Lower storage TCO',
  },
  select_one: {
    id: 'wuVrZj',
    defaultMessage: 'Select One',
  },
  how_modern_system_tooltip1: {
    id: 'phpxSQ',
    defaultMessage: 'Basic = My organization is on rotating media',
  },
  how_modern_system_tooltip2: {
    id: 'VMutDt',
    defaultMessage: 'Defined = My organization uses a hybrid flash mix',
  },
  infrastructure: {
    id: 'dA+hnZ',
    defaultMessage: 'Infrastructure',
  },
  how_modern_system_tooltip3: {
    id: 'USOk92',
    defaultMessage: 'Integrated = My organization uses All-Flash',
  },
  view_modify_assumption: {
    id: 'uouW3z',
    defaultMessage: 'View / Modify Model Assumptions',
  },
  usable_capacity: {
    id: 'Ck+5p8',
    defaultMessage: 'Usable capacity (TB)',
  },
});

export default messages;
